
<template>
  <j-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @cancel="handleCancel"
    :bodyStyle="bodyStyle"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <div class="form-contain" style="height: auto">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="$t(item.title)">
            <div v-if="activeKey == 1" style="height: calc(70vh - 90px);overflow-y: auto;">
              <a-divider orientation="left">
                {{ $t('表端实时数据') }}
              </a-divider>
              <detail-list>
                <detail-list-item :term="$t('接收时间')">
                  {{model.sysTime}}
                </detail-list-item>
                <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                <detail-list-item :term="$t('IMEI号')">{{model.meterImei}}</detail-list-item>
                <!--
                <detail-list-item term="表类型">
                  {{$t(meterTypeObj[model.meterType])}}
                </detail-list-item>
                -->
                <detail-list-item :term="$t('表端时间')">
                  {{model.meterTime}}
                </detail-list-item>
                <detail-list-item :term="$t('电池电压(V)')">
                  {{model.meterBatteryVoltage}}
                </detail-list-item>
                <detail-list-item :term="$t('累计发送成功次数')">
                  {{model.sumSuccessCount}}
                </detail-list-item>
                <detail-list-item :term="$t('累计发送失败次数')">
                  {{model.sumFailedCount}}
                </detail-list-item>
                <detail-list-item :term="$t('累积开阀时间(分钟)')">
                  {{model.meterTotalUse}}
                </detail-list-item>
                <detail-list-item :term="$t('剩余开阀时间(分钟)')">
                  {{model.meterRemainNum}}
                </detail-list-item>
                <detail-list-item :term="$t('内核温度(℃)')">
                  {{model.innerTemp}}
                </detail-list-item>
                <detail-list-item :term="$t('充值次数')">
                  {{model.meterPayTimes}}
                </detail-list-item>
                <detail-list-item :term="$t('本次通讯耗时(s)')">
                  {{model.meterUpConnNetTime}}
                </detail-list-item>
                <detail-list-item :term="$t('定时上报频率')">
                  {{model.meterUpCycle}}
                </detail-list-item>
                <detail-list-item :term="$t('阀门开度')">
                  {{model.openValveNum}}
                </detail-list-item>
                <detail-list-item term="CSQ">
                  {{model.meterCsq}}
                </detail-list-item>
              </detail-list>
              <a-divider orientation="left">
                {{ $t('表端状态信息') }}
              </a-divider>
              <detail-list>
                <detail-list-item :term="$t('状态字信息')">
                  <span>ST0:&nbsp;{{model.meterStatus1==''||model.meterStatus1==null?model.meterStatus1:model.meterStatus1.toString(16)}}</span>
                  <span>;ST1:&nbsp;{{model.meterStatus2==''||model.meterStatus2==null?model.meterStatus2:model.meterStatus2.toString(16)}}</span>
                  <span>;ST2:&nbsp;{{model.meterStatus3==''||model.meterStatus3==null?model.meterStatus3:model.meterStatus3.toString(16)}}</span>
                  <span>;ST3:&nbsp;{{model.meterStatus4==''||model.meterStatus4==null?model.meterStatus4:model.meterStatus4.toString(16)}}</span>
                </detail-list-item>
                
                <detail-list-item :term="$t('电池状态')">
                  {{model.meterBatteryStatus==0?$t('正常'):model.meterBatteryStatus==1?$t('一级欠压'):model.meterBatteryStatus==2?$t('二级欠压'):''}}
                </detail-list-item>
                <detail-list-item :term="$t('上报方式')">
                  {{$t(SendWayObj[model.meterUpWay]?SendWayObj[model.meterUpWay]: $t('未知'))}}
                </detail-list-item>
                <detail-list-item :term="$t('上报次数')">
                    {{model.meterUpTimes+1}}
                  </detail-list-item>
                <detail-list-item :term="$t('磁干扰')">
                  {{model.meterMagnetic==0?$t('正常'):model.meterMagnetic==1?$t('有'):''}}
                </detail-list-item>
                <detail-list-item :term="$t('终端协议版本号')">
                  {{model.meterSoftVersion}}
                </detail-list-item>
                <detail-list-item :term="$t('阀门状态')">
                  {{$t(Mn100FkStatusObj[model.meterValveStatus])}}
                </detail-list-item>
                <detail-list-item :term="$t('阀门是否有故障')">
                  {{model.meterValveFault==0?$t('正常'):model.meterValveFault==1?$t('有关阀故障'):model.meterValveFault==2?$t('有开阀故障'):model.meterValveFault==3?$t('开关阀故障'):''}}
                </detail-list-item>
                <template v-if="Object.keys(meterStatusObj).length>0">
                  <detail-list-item :term="$t('强制阀控状态')">
                    {{meterStatusObj.fkForceStatus==0?$t('非强制状态'):$t('强制状态') }}
                  </detail-list-item>
                  <detail-list-item :term="$t('刷卡上报使能')">
                    {{meterStatusObj.cardUpEnable |transEnableFilter}}
                  </detail-list-item>
                  <detail-list-item :term="$t('上电上报使能')">
                    {{meterStatusObj.powerUpEnable |transEnableFilter}}
                  </detail-list-item>
                  <detail-list-item :term="$t('计费结束关阀使能')">
                    {{meterStatusObj.calEndFkEnable |transEnableFilter}}
                  </detail-list-item>
                  <detail-list-item :term="$t('余额报警')">
                    {{meterStatusObj.remainAlarm |transHasFilter}}
                  </detail-list-item>
                  <detail-list-item :term="$t('透支关阀报警')">
                    {{meterStatusObj.overflowCloseFkAlarm |transHasFilter}}
                  </detail-list-item>
                  <detail-list-item term="LVD">
                    {{meterStatusObj.LVD |transHasFilter}}
                  </detail-list-item>
                  <detail-list-item term="WDT">
                    {{meterStatusObj.WDT |transHasFilter}}
                  </detail-list-item>
                  <detail-list-item term="PCA">
                    {{meterStatusObj.PCA |transHasFilter}}
                  </detail-list-item>
                  <detail-list-item term="lockup">
                    {{meterStatusObj.lockup |transHasFilter}}
                  </detail-list-item>
                  <detail-list-item term="CSS">
                    {{meterStatusObj.CSS |transHasFilter}}
                  </detail-list-item>
                  <detail-list-item term="NRST">
                    {{meterStatusObj.NRST |transHasFilter}}
                  </detail-list-item>
                </template>
              </detail-list>
              <a-divider orientation="left">
                {{ $t('表端信号状态') }}
              </a-divider>
              <detail-list>
                <detail-list-item :term="$t('接收信号功率(RSRP)')">
                  {{model.meterSignalStrength.rsrp!=null?model.meterSignalStrength.rsrp:'--'}}dBm
                </detail-list-item>
                <detail-list-item :term="$t('信噪比(SNR)')">
                  {{model.meterSignalStrength.snr!=null?model.meterSignalStrength.snr:'--'}}dB
                </detail-list-item>
                <detail-list-item :term="$t('信号强度(CSQ)')">
                  {{model.meterSignalStrength.csq!=null?model.meterSignalStrength.csq:'--'}}
                </detail-list-item>
                <detail-list-item :term="$t('覆盖等级(ECL)')">
                  {{model.meterSignalStrength.sigLevel!=null?model.meterSignalStrength.sigLevel:'--'}}
                </detail-list-item>
                <detail-list-item :term="$t('小区ID(CellID)')">
                  {{model.meterSignalStrength.cellId!=null?model.meterSignalStrength.cellId: '--'}}
                </detail-list-item>
              </detail-list>
              <!--
              <template v-if="model.meterType==80">
              <a-divider orientation="left">
                解析数据
              </a-divider>
              <detail-list :col="1">
                <detail-list-item term="解析内容">
                  <a-textarea v-model="model.meterUpDetail" :rows="3"></a-textarea>
                </detail-list-item>
              </detail-list>
              </template>
              -->
            </div>
            <!-- <div v-else="model.meterType!=80?activeKey==4">
            </div> -->
            <a-table
                v-else-if="activeKey != 1"
                ref="table"
                size="middle"
                :scroll="{y:'calc(70vh - 160px)'}"
                :pagination="false"
                bordered
                rowKey="id"
                :columns="activeKey == 4?columss:columns"
                :dataSource="dataSource"
                :loading="loading"
                class="j-table-force-nowrap"
                >
              </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>

  import pick from 'lodash.pick'
  import i18n from '@/i18n'
  import {isNull} from '@/utils/validate'
  import {getNextDate,getDateTimeByMiniteInterval} from '@/utils/util'
  import {netTypeObj,Mn100FkStatusObj,SendWayObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item

  export default {
    name: 'MeterUpDataForm',
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        title:this.$t("操作"),
        netTypeObj,
        Mn100FkStatusObj,
        meterTypeObj,
        SendWayObj,
        model: {},
        confirmLoading: false,
        bodyStyle: {
          height: '70vh',
          'overflow-y': 'hidden'
        },
        visible: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/meterUpData/add",
          edit: "/jeecg-charge/meter/meterUpData/edit",
          queryById: "/jeecg-charge/meter/meterUpData/queryById"
        },
        activeKey: 1,
        tabList: [
          
        ],
        formateRemarkObj: {
          intervalFlowList: [],// 间隔流量
          crowFlowList : [],// 密集采样数据
          daySumFlowList: [],// 日结累计流量
        },
        loading: false,
        dataSource: [],
        meterStatusObj: {}
      }
    },
    filters: {
      transEnableFilter(flag) {
        if(flag === null||flag===''){
          return '';
        }
        if(flag == 0) {
          return i18n.t('不使能');
        }else if(flag == 1) {
          return i18n.t('使能');
        }else{
          return i18n.t('未知');
        }
        
      },
      transHasFilter(flag) {
        if(flag === null||flag===''){
          return '';
        }
        if(flag == 0) {
          return i18n.t('无');
        }else if(flag == 1) {
          return i18n.t('有');
        }else{
          return i18n.t('未知');
        }
      }
    },
    created () {
    },
    computed: {
      // i18n：表头使用 computed 以响应语言切换
      columss() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:(t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('时间'),
            align:"center",
            dataIndex: 'date'
          },{
            title: this.$t('日结累计流量(m³)'),
            align:"center",
            dataIndex: 'total'
          }
        ]
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:(t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('时间'),
            align:"center",
            dataIndex: 'date'
          },{
            title: this.$t('数据'),
            align:"center",
            dataIndex: 'total'
          }
        ]
      },
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        if (this.model.meterType!=80) {
          console.log(this.tabList);
          this.tabList = [
            {key: 1,title: this.$t('基本信息')}
          ]
          console.log(this.tabList);
        } else {
          this.tabList = [
            {key: 1,title: this.$t('基本信息')},
            //{key: 2,title: '间隔流量'},//20220223因为有时不上报，为了统一这块取消掉展示统一在实列表的更多中去看
            //{key: 3,title: '密集采样数据'},
            {key: 4,title: this.$t('日结累计流量')},
          ]
        }
        console.log(this.model);
        this.visible = true;
        if(this.model.meterSignalStrength) {
          this.model.meterSignalStrength = JSON.parse(this.model.meterSignalStrength)
        }
        this.formateRemark(this.model.meterUpDetail)
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'meterId','meterType','meterTime','sysTime','meterSignalStrength','meterTotalUse','meterJsrUse','meterRemainNum','meterBatteryVoltage','meterDayUse','meterDayHighFlow','meterDayHighTime','meterStatus1','meterStatus2','meterStatus3','meterStatus4','meterSaveFault','meterUpWay','meterBatteryStatus','meterValueStatus','meterMagnetic','meterUpTimes','meterUpNoResponse','meterUpData','meterIotType','meterDevId','meterAppId','remark','createTime'))
      },
      formateRemark(data) {
        // 格式化remark的值显示为列表格式
        let remark = JSON.parse(data)
        console.log(remark)
        if(!remark) {
          return
        }
        let tag6 = remark.tag6 // 间隔流量
        let tag7 = remark.tag7 // 密集采样数据
        let tag21 = remark.tag21 // 日结累计流量
        let tag2 = remark.tag2 // 实时数据
        if(tag6) {
          let date = getNextDate(this.model.meterTime.substr(0,10),-1)
          let timeArr = getDateTimeByMiniteInterval(0,0+tag6.recordInterval,tag6.recordInterval,tag6.recordCount)
          for(let i = 0;i< tag6.recordCount;i++) {
            let dateTime = date + ' ' + timeArr[i]
            if(tag6.positiveSumFlow[i]<0) {
              
              this.formateRemarkObj.intervalFlowList.push({id: i, total: this.$t('无数据'),date: dateTime})
            }else{
              this.formateRemarkObj.intervalFlowList.push({id: i, total: tag6.positiveSumFlow[i],date: dateTime})
            }
          }
        }
        if(tag7) {
          let date = getNextDate(this.model.meterTime.substr(0,10),-1)
          let timeArr = getDateTimeByMiniteInterval(parseInt(tag7.startTime.substr(0,2)),parseInt(tag7.startTime.substr(2,2))+tag7.recordInterval,tag7.recordInterval,tag7.recordCount)
          for(let i = 0;i< tag7.recordCount;i++) {
            let dateTime = date + ' ' + timeArr[i]
            this.formateRemarkObj.crowFlowList.push({id: i, total: tag7.positiveSumFlow[i]<0?this.$t('无数据'):tag7.positiveSumFlow[i],date: dateTime})
          }
        }
        if(tag21&&tag21.positiveSumFlow) {
          for(let i = 0;i< tag21.recordCount;i++) {
            let myDate = new Date()
            let str = (myDate.getFullYear()+'').substr(0,2)+''+tag21.startDate.substr(0,2)+'-'+tag21.startDate.substr(2,2)+'-'+tag21.startDate.substr(4,2)
            let date = getNextDate(str,-(i))
            if(i==0) {
              date = (myDate.getFullYear()+'').substr(0,2)+''+tag21.startDate.substr(0,2)+'-'+tag21.startDate.substr(2,2)+'-'+tag21.startDate.substr(4,2)
            }
            if(isNull(tag21.positiveSumFlow[i])||tag21.positiveSumFlow[i]<0) {
              this.formateRemarkObj.daySumFlowList.push({id: i, total: this.$t('无数据'),date: date})
            }else{
              this.formateRemarkObj.daySumFlowList.push({id: i, total: tag21.positiveSumFlow[i]/1000,date: date})
            }
          }
        }
        if(tag2) {
          this.model.sumSuccessCount = tag2.sumSuccessCount;
          this.model.sumFailedCount = tag2.sumFailedCount;
          this.model.innerTemp = tag2.innerTemp;
          this.model.remainMoneyFlag = tag2.remainMoneyFlag;
          this.model.meterWarnMoney = tag2.meterWarnMoney;
          this.model.openValveNum = tag2.openValveNum;
          this.model.meterCsq = tag2.csq;
          console.log("--------------")
          console.log(tag2)
          console.log(tag2.statusAnlysis)
          if(tag2.statusAnlysis) {
            this.meterStatusObj = tag2.statusAnlysis;
          }
        }
      },
      changeTab() {
        // 切换tab
        console.log(this.activeKey)
        this.dataSource = this.activeKey == 2?this.formateRemarkObj.intervalFlowList:this.activeKey == 3? this.formateRemarkObj.crowFlowList: this.formateRemarkObj.daySumFlowList
      },
      close () {
        this.$emit('close');
        this.activeKey = 1;
        this.formateRemarkObj = this.$options.data.call(this).formateRemarkObj;
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
</style>